import React, { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import AAutoComplete from "../../../common/form-fields-mui/AAutoComplete";
import AButton from "../../../common/form-fields-mui/AButton";
import {
  useFetchProgramActionReason,
  useFetchProgramActions,
  useFetchProgramHistory,
  useUpdateProgramActionReason,
} from "./hook";
import ALoader from "../../../common/a-loader";
import { successToast } from "../../../common/utils/methods/toasterFunctions/function";
import { useModal } from "../../../../../../contexts/customModal";
import ActionHistoryTable from "./ActionHistoryTable";
import { IoMdRefresh } from "react-icons/io";
import DiscontinueFeedback from "./DiscontinueFeedback";
import { useGetChequeDetails } from "modules/paymentManagement/cheque-management/hooks/useDepositCheque";
import ShowPendingCheques from "modules/paymentManagement/cheque-management/components/ShowPendingCheques";
import { ReactComponent as WarningInfoCircle } from "assets/img/svg/warningInfoCircle.svg";

const filterAUDTReason = (isAccess, reasons = []) => {
  if (isAccess) return reasons;
  return reasons?.filter((item) => !item.value?.includes("AUDT"));
};
const UpdateProgramActionForm = ({
  programAction,
  applicationId,
  fetchData,
  updateProgramActionPermissions,
  programActionHistory,
}) => {
  const [form, setForm] = useState({
    programAction: programAction,
    reason: "",
  });
  useEffect(() => {
    setForm({
      programAction: programAction,
      reason: "",
    });
  }, [programAction, applicationId]);
  const isAUDT = (updateProgramActionPermissions || []).includes("C");
  const programActions = useFetchProgramActions(programAction);
  const programActionReasons = useFetchProgramActionReason(form?.programAction);
  const updatedReasons = filterAUDTReason(isAUDT, programActionReasons);
  const [isUpdating, error, updateProgApi] = useUpdateProgramActionReason();
  const { chequeReceipts } = useGetChequeDetails({ applicationId });
  const { showModal, hideModal } = useModal();
  const showHistoryHandler = () => {
    showModal({
      title: `Action History`,
      maxWidth: "md",
      content: (
        <div style={{ minWidth: "650px" }}>
          <ActionHistoryTable data={programActionHistory} />
        </div>
      ),
    });
  };
  const updateProgActionHandler = async () => {
        hideModal()
    if (applicationId && form?.reason) {
      const { reason, programAction } = form;
      const response = await updateProgApi({
        applicationId,
        progReason: reason?.value,
        progAction: programAction?.value,
      });
      if (response?.code === 200) {
        fetchData();
        successToast("Program Action updated successfully");
      }
    }
  };

  const validateProgramActionChange = () => {
    if (
      "DISC" === form.programAction?.value &&
      chequeReceipts?.chequeNoList?.length > 0
    ) {
      showModal({
        title: <WarningInfoCircle />,
        maxWidth: "md",
        content: (
          <div style={{ minWidth: "500px" }}>
            <ShowPendingCheques
              chequeNos={chequeReceipts?.chequeNoList}
              psid={chequeReceipts?.psid}
              applicationId={applicationId}
              isDiscontinued={true}
              hideModal={hideModal}
              businessAreaId={chequeReceipts?.businessArea}
              cashierOffice={chequeReceipts?.cashierOffice}
              onProceed={updateProgActionHandler}
            />
          </div>
        ),
      });
    } else {
      updateProgActionHandler();
    }
  };

  const isDisableReasonBtn = () => {
    if (programAction === "APPL" && form.programAction?.value === "MATR") {
      return false;
    }
    return !form?.reason;
  };

  return (
    <>
      <Row>
        <Col>
          <AAutoComplete
            label="New Program Action"
            items={programActions}
            currentValue={form.programAction}
            isMulti={false}
            handleChange={(value) =>
              setForm((prev) => ({ ...prev, programAction: value, reason: "" }))
            }
            // disabled={disabled}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <AAutoComplete
            label="Action Reason"
            currentValue={form.reason}
            items={updatedReasons}
            isMulti={false}
            handleChange={(value) =>
              setForm((prev) => ({ ...prev, reason: value }))
            }
          />
        </Col>
      </Row>
      <Row className="mt-3">
        {isUpdating ? (
          <ALoader />
        ) : (
          <AButton
            updatedStyle={{ width: "92%" }}
            size="xs"
            onClick={validateProgramActionChange}
            variant="primary_filled"
            disabled={isDisableReasonBtn()}
          >
            Save changes
          </AButton>
        )}
      </Row>
      <div className=" mt-4 d-flex align-align-center justify-content-between">
        <div onClick={showHistoryHandler} className="d-flex align-items-center">
          <IoMdRefresh /> Action History
        </div>
        <div>
          <DiscontinueFeedback applicationId={applicationId} />
        </div>
      </div>
    </>
  );
};

export default UpdateProgramActionForm;
